const actionTypes = (actionName) => ({
  pending: `${actionName}_PENDING`.toUpperCase(),
  success: `${actionName}_SUCCESS`.toUpperCase(),
  failed: `${actionName}_FAILED`.toUpperCase(),
  reset: `${actionName}_RESET`.toUpperCase(),
})

export default actionTypes
